import DataGrid, {
    Column,
    FilterRow,
    MasterDetail,
    Paging,
    Scrolling
} from 'devextreme-react/data-grid';
import React, { useState } from "react";
import { Col, Row } from "reactstrap";
import useFormatMessage from '../../../../utils/useFormatMessage';
import MasterDetailGrid from "./MasterDetailGrid";
import UpdateModal from "./UpdateModal";

export default function PermissionTable({ dataSource, triger, setTriger, dataGridRef }) {

    const [modalUpdate, setModalUpdate] = useState(false)
    const [selectedId, setSelectedId] = useState()
    const { t } = useFormatMessage();
    function settingsCell(data) {
        return (
            <Row className="d-flex justify-content-around">
                <Col lg="3" className="d-flex justify-content-center">
                    <i className='fa fa-edit mt-2' onClick={() => { setSelectedId(data.data); setModalUpdate(true); }} style={{ fontSize: "18px", cursor: "pointer", color: "blue" }}></i>
                </Col>
                {/* <Col lg="3" className="d-flex justify-content-center">
                    <i onClick={() => { setSelectedId(data.data.KopusFormId); setModalDelete(true); }} className='fa fa-trash mt-2' style={{fontSize:"18px", cursor: "pointer", color: "blue"}}></i>
                </Col> */}
            </Row>);
    }

    return (
        <DataGrid
            dataSource={dataSource}
            showBorders={true}
            allowColumnResizing={true}
            // onExporting={onExporting}
            height="65vh"
            rowAlternationEnabled={true}
            showColumnLines={true}
            showRowLines={true}
            ref={dataGridRef}
        >
            {/* <Export enabled={true} /> */}
            <FilterRow visible={true} />
            {/* <Column dataField="PermissionGroupId" allowSorting={false} alignment="center" caption="Yetki Grubu ID" /> */}
            <Column dataField="permission_group_name" selectedFilterOperation={"contains"} caption={t("Yetki Grubu Adı")} alignment="center" />
            <MasterDetail
                enabled={true}
                component={MasterDetailGrid}
            />
            <Column caption={t("İşlem")} allowSorting={false} cellRender={settingsCell} alignment="center" allowExporting={false} />
            {/* <Pager allowedPageSizes={pageSizes} showPageSizeSelector={true} />
            <Paging defaultPageSize={10} /> */}
            <Scrolling columnRenderingMode="virtual" />
            <Paging enabled={false} />
            <UpdateModal setTriger={setTriger} triger={triger} dataId={selectedId} modalUpdate={modalUpdate} setModalUpdate={setModalUpdate} />
        </DataGrid>
    )
}